import AvisoVerificacion from "./AvisoVerificacion";
export default AvisoVerificacion;